import React from 'react';
import { ArrowElement } from '../../types/arGuides';

interface AnimatedArrowProps {
  arrow: ArrowElement;
}

export const AnimatedArrow: React.FC<AnimatedArrowProps> = ({ arrow }) => {
  const fromPos = typeof arrow.from === 'object' && 'selector' in arrow.from ? null : arrow.from;
  const toPos = typeof arrow.to === 'object' && 'selector' in arrow.to ? null : arrow.to;

  if (!fromPos || !toPos) return null;

  const startX = fromPos.x + fromPos.width / 2;
  const startY = fromPos.y + fromPos.height / 2;
  const endX = toPos.x + toPos.width / 2;
  const endY = toPos.y + toPos.height / 2;

  const controlX = (startX + endX) / 2;
  const controlY = startY - 50;

  const pathData = `M ${startX} ${startY} Q ${controlX} ${controlY} ${endX} ${endY}`;

  const animationClass = arrow.animation === 'draw' ? 'animate-draw' :
                        arrow.animation === 'bounce' ? 'animate-bounce' :
                        'animate-fade';

  return (
    <g className={animationClass}>
      <path
        d={pathData}
        stroke="var(--cm-trigo)"
        strokeWidth="3"
        fill="none"
        strokeDasharray="10, 5"
      />
      <polygon
        points={`${endX},${endY} ${endX - 10},${endY - 15} ${endX + 10},${endY - 15}`}
        fill="var(--cm-trigo)"
      />
    </g>
  );
};
